module.exports = __webpack_public_path__ + "braveuistatic/img/apps/www.bravenet.com/src/assets/img/blogs/bravenet_blogs_drag_and_drop_embeddable_content.png";